import { Space } from '@sravni/react-design-system';
import type { FC } from 'react';
import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib';

import { selectCreditPurposeInfoData } from 'entities/creditForm';
import { selectIsSelectedProductTypeFeatureEnabled } from 'entities/siteSettings';

import { MobileApp } from 'features/MobileApp';
import { ProductTypeSelection, resolveActiveProductTypeTabTitle } from 'features/ProductTypeSelection';
import {
  AccordionModalForm,
  SUBTITLE_APP_MOBILE,
  type TCreditPurposeAccordionProps,
  TITLE_APP_MOBILE,
} from 'features/UpdateCreditPurposeInfo';

import styles from './CreditPurposeAccordionModalForm.module.scss';

export const CreditPurposeAccordionModalForm: FC<TCreditPurposeAccordionProps> = (props) => {
  const isProductTypeSelectionEnabled = useAppSelector(selectIsSelectedProductTypeFeatureEnabled);
  const creditPurposeData = useAppSelector(selectCreditPurposeInfoData);
  const productTabTitle = isProductTypeSelectionEnabled
    ? resolveActiveProductTypeTabTitle(creditPurposeData)
    : undefined;

  const mobileApp = useMemo(
    () => ({
      mobile: (
        <Space className="h-mt-16 h-mb-8">
          <MobileApp
            color="blue"
            title={TITLE_APP_MOBILE}
            subtitle={SUBTITLE_APP_MOBILE}
          />
        </Space>
      ),
      desktop: (
        <Space className="h-mt-16 h-mb-8">
          <MobileApp
            color="blue"
            title={TITLE_APP_MOBILE}
            subtitle={SUBTITLE_APP_MOBILE}
            desktopTextBlockClassName={styles.appMobileTextBlockDesktop}
          />
        </Space>
      ),
    }),
    [],
  );

  return (
    <AccordionModalForm
      {...props}
      productCardBlock={isProductTypeSelectionEnabled ? <ProductTypeSelection /> : undefined}
      productTabTitle={productTabTitle}
      mobileApp={mobileApp}
    />
  );
};
